import { render, staticRenderFns } from "./IconThumbsUp.vue?vue&type=template&id=6a77aaba"
import script from "./IconThumbsUp.vue?vue&type=script&lang=js"
export * from "./IconThumbsUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports